export const ReportTypeEnum = {
  Scheduled: 'scheduled',
  Expired: 'expired',
};

export const SortTypeEnum = {
  LastName: 'lastName',
  StudentNumber: 'studentNumber',
  FamilyNumber: 'systemId',
};

export const GroupTypeEnum = {
  None: 'none',
  School: 'school',
};

export const ProvisionTypeEnum = {
  Both: 0,
  CEP: 1,
  Traditional: 2,
};

export const CarryoverType = {
  Both: 0,
  YearEnd: 1,
  CEP_Transfer: 2,
};



// WEBPACK FOOTER //
// ./src/pages/mbereport/helpers/Enumeration.js